import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { CardCell } from './CardCell.js';
const getSubTextLunch = ({ lunchHour, hasLunch = false, status = false }) => {
    if (!status) {
        return 'Не работает';
    }
    return lunchHour && hasLunch ? `Перерыв ${lunchHour}` : lunchHour;
};
export const renderDay = ({ title, status, workTime, lunchHour, hasLunch }, i) => (_jsx(CardCell, { label: title, value: status && workTime ? workTime : '', subText: getSubTextLunch({ lunchHour, hasLunch, status }), subColor: !status || hasLunch ? 'text-error' : 'text-green-dark' }, String(i)));
//# sourceMappingURL=renderDay.js.map